var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-icon-A",
    x: 2.5,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "google-icon-A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.099 47.672H40V32.603h39.323A40.53 40.53 0 0 1 80 40a40.51 40.51 0 0 1-.729 7.671 39.85 39.85 0 0 1-12.692 22.27L52.675 59.339a23.53 23.53 0 0 0 9.425-11.668z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.95 21.214L66.327 9.837C59.302 3.706 50.099 0 40 0A39.91 39.91 0 0 0 4.143 22.197L17.485 32.46A23.51 23.51 0 0 1 40 15.89c5.686 0 10.889 1.994 14.951 5.323z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.708 47.13L3.965 57.438C1.423 52.173 0 46.259 0 40c0-6.404 1.49-12.447 4.143-17.803L17.485 32.46c-.681 2.208-1.047 4.556-1.047 6.992 0 2.691.446 5.273 1.27 7.678z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.709 47.13L3.965 57.438A39.91 39.91 0 0 0 40.001 80a39.87 39.87 0 0 0 26.579-10.059L52.675 59.339c-3.655 2.328-8.002 3.675-12.675 3.675A23.51 23.51 0 0 1 17.709 47.13z",
    fill: "#34a853"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.84030875.svg";
export { ForwardRef as ReactComponent };